import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-ui";

interface MarkdownProps {
    components?: ReactMarkdown.TransformOptions["components"];
    children: string;
    theme?: "dark" | "light";
}

export const Markdown = (props: MarkdownProps) => {
    const defaultComponents: ReactMarkdown.TransformOptions["components"] = {
        p: ({ children }) => <div>{children}</div>,
        a: ({ href, children }) => (
            <Link href={href} target="_blank" rel="noreferrer">
                {children}
            </Link>
        ),
    };

    return <ReactMarkdown components={{ ...defaultComponents, ...props.components }}>{props.children}</ReactMarkdown>;
};
